"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _useTrackingLayer = _interopRequireDefault(require("../utils/useTrackingLayer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Lincx = function Lincx(_ref) {
  var tracking = _ref.tracking,
      email = _ref.email;
  var componentIsMounted = (0, _react.useRef)(true);
  (0, _useTrackingLayer.default)(tracking, email);
  (0, _react.useEffect)(function () {
    if (componentIsMounted.current) {
      var sct;

      (function () {
        sct = document.createElement('script'); // let sctHl = document.getElementsByTagName('script')[0];

        var containerDiv = document.getElementById('lincx-div');
        sct.type = 'text/javascript';
        sct.src = 'https://api.lincx.com/load';
        sct.setAttribute('data-zone-id', 'fk41da');
        sct.setAttribute('data-affsub', 'bluekeel');
        sct.setAttribute('data-category', '');
        sct.setAttribute('data-origin-id', '3x03to0');
        sct.setAttribute('data-s1', 'bluekeel');
        sct.setAttribute('data-s2', tracking.sid);
        sct.setAttribute('data-s3', tracking.eid);
        containerDiv.parentNode.insertBefore(sct, containerDiv);
      })();
    }

    return function () {
      componentIsMounted.current = false;
    }; // eslint-disable-next-line
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "lincx-div"
  });
};

var _default = Lincx;
exports.default = _default;

//# sourceMappingURL=Lincx.jsx.map